export const environment = {
  firebase: {
    apiKey: "AIzaSyBgPG2ahe_X1s9Acfh18Nhf175y44DXT0U",
    authDomain: "pillway-dev1.firebaseapp.com",
    databaseURL: "https://pillway-dev1.firebaseio.com",
    projectId: "pillway-dev1",
    storageBucket: "pillway-dev1.appspot.com",
    messagingSenderId: "790624198376",
    appId: "1:790624198376:web:95241fb821bb477489335d",
    measurementId: "G-5R9NR1756Z"

  },
  firebasePlQc: {
    apiKey: 'AIzaSyBgPG2ahe_X1s9Acfh18Nhf175y44DXT0U',
    authDomain: 'pillway-dev1.firebaseapp.com',
    databaseURL: 'https://pillway-dev1.firebaseio.com',
    projectId: 'pillway-dev1',
    storageBucket: 'pillway-dev1.appspot.com',
    messagingSenderId: '790624198376',
    appId: '1:790624198376:web:95241fb821bb477489335d',
    measurementId: 'G-5R9NR1756Z',
  },
  firebaseSunlife: {
    apiKey: "AIzaSyCU7-ZNPTdOo8r6LncW5D1Hjzy-Kr-fDYU",
    authDomain: "sl-lumino-dev.firebaseapp.com",
    databaseURL: "https://sl-lumino-dev.firebaseio.com",
    projectId: "sl-lumino-dev",
    storageBucket: "sl-lumino-dev.appspot.com",
    messagingSenderId: "1071312343145",
    appId: "1:1071312343145:web:bc5a7656a045139c4092f8",
    //measurementId: "G-W8ET1J54XW"
    measurementId: "G-T6XBXZCPYY"
  },
  firebaseQc: {
    apiKey: "AIzaSyCU7-ZNPTdOo8r6LncW5D1Hjzy-Kr-fDYU",
    authDomain: "sl-lumino-dev.firebaseapp.com",
    databaseURL: "https://sl-lumino-dev.firebaseio.com",
    projectId: "sl-lumino-dev",
    storageBucket: "sl-lumino-dev.appspot.com",
    messagingSenderId: "1071312343145",
    appId: "1:1071312343145:web:bc5a7656a045139c4092f8",
    //measurementId: "G-W8ET1J54XW"
    measurementId: "G-T6XBXZCPYY"
  },
  firebaseWylo: {
      apiKey: "AIzaSyD5QTQduPhmwRlBBq2rEEfx9CZ00uNbHjQ",
      authDomain: "wylo-dev-65a3f.firebaseapp.com",
      projectId: "wylo-dev-65a3f",
      storageBucket: "wylo-dev-65a3f.firebasestorage.app",
      messagingSenderId: "902469391089",
      appId: "1:902469391089:web:8a1373592725f178868f50",
      measurementId: "G-H5RHPGJBL4",
      databaseURL: "https://wylo-dev-65a3f.firebaseio.com"
  },
  firebaseTitan: {
    apiKey: 'AIzaSyDz_Y_k2sljv5EoroR2FtDkqv8lnkJFB_I',
    authDomain: 'titan-dev-ece43.firebaseapp.com',
    databaseURL: 'https://titan-dev-ece43.firebaseio.com',
    projectId: 'titan-dev-ece43',
    storageBucket: 'titan-dev-ece43.firebasestorage.app',
    messagingSenderId: '384772548053',
    appId: '1:384772548053:web:5fe44701bcf701ae1a495c',
    measurementId: 'G-T6XBXZCPYY'
  },
  firebaseTitanQc: {
    apiKey: 'AIzaSyDz_Y_k2sljv5EoroR2FtDkqv8lnkJFB_I',
    authDomain: 'titan-dev-ece43.firebaseapp.com',
    databaseURL: 'https://titan-dev-ece43.firebaseio.com',
    projectId: 'titan-dev-ece43',
    storageBucket: 'titan-dev-ece43.firebasestorage.app',
    messagingSenderId: '384772548053',
    appId: '1:384772548053:web:5fe44701bcf701ae1a495c',
    measurementId: 'G-T6XBXZCPYY'
  },
  production: false,
  isLiveEnv: false,
  apiUrl: 'https://beta.pillway.com/api/',
  googleMapKey: 'AIzaSyBV54mpVmCEA05BwLDEHLK63oUvSazOe9U',
  jumpcloudRedirectURL: 'https://sso.jumpcloud.com/saml2/betapilldash',
  jumpcloudLogoutURL: 'https://console.jumpcloud.com/userconsole/logout',
  AuthKeyJumpcloud: "ce91765fb4dd3166b7de748b4f5da294b9501bbc",
  clientIdOkta: '0oa10ujdurdDkHLYu5d7',
  AuthKeyOkta: "QEuxAah0juYd2o7dvEqKpAVxkGFwwvqT1jF8Wp5f",
  googleWorkspaceRedirectURL: 'https://accounts.google.com/o/saml2/initsso?idpid=C03l16wag&spid=570423793426&forceauthn=false',
  AuthKeyGoogleWorkspace: "AF8359A9181744F2E744DD1BCC1BD",
  encryptionKey: 'cbc@g2iabcs9jtz5',
  encryptionIv: 'cbc@5n7abc3a5z7p',
};
